import { AppLayout } from "../../Layouts";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { DashboardGreating } from "../../Components/Features/DashBoard/DashboardGreating";
import { DashboardInfoCards } from "../../Components/Features/DashBoard/DashboardInfoCards";

export const DashboardPage = () => {
  const {
    i18n: { language },
  } = useTranslation();

  moment.locale(language);
  return (
    <AppLayout>
      <div className="w-full flex flex-col p-2 sm:p-9  ">
        <div className=" w-full flex flex-col justify-center mt-5 md:mt-0 items-center">
          <DashboardGreating />
          <DashboardInfoCards />
        </div>
      </div>
    </AppLayout>
  );
};
